import script from "./CompetitionSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionSettings.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionSettings.vue?vue&type=style&index=0&id=885c44dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-885c44dc"]])

export default __exports__